<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- FORMULÁRIO -->
<form *ngIf="!loading" [formGroup]="formCompanyContact" class="mt-4 mb-4">

  <!-- HEADER -->
  <div class="border-b pb-4">
    <p class="font-medium text-base text-westetics-neutral-950">
      Contato
    </p>
    <p class="text-sm text-westetics-neutral-800 mt-2">
      Informe os dados de contato da empresa
    </p>
  </div>

  <!-- E-MAIL LEGAL -->
  <div class="mt-4">
    <div class="w-full">
      <label for="legalEmail" class="block mb-2 text-sm font-medium text-westetics-neutral-950">E-mail Legal*</label>
      <input
        type="email"
        id="legalEmail"
        formControlName="legalEmail"
        class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="email.legal@empresa.com"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyContact.controls['legalEmail']?.invalid &&
        formCompanyContact.controls['legalEmail']?.touched
      ">
        Insira um e-mail válido.
      </span>
    </div>
  </div>

  <!-- CAMPOS DO ADMINISTRADOR (apenas no modo de criação) -->
  <ng-container *ngIf="!isEditMode">

    <!-- NOME DO ADMIN -->
    <div class="mt-4">
      <div class="w-full">
        <label for="ownerName" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Nome do Administrador*</label>
        <input
          type="text"
          id="ownerName"
          formControlName="ownerName"
          class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="Nome do administrador principal"
        />
        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
          formCompanyContact.controls['ownerName']?.invalid &&
          formCompanyContact.controls['ownerName']?.touched
        ">
          Insira o nome do administrador.
        </span>
      </div>
    </div>

    <!-- E-MAIL DO ADMIN -->
    <div class="mt-4">
      <div class="w-full">
        <label for="ownerEmail" class="block mb-2 text-sm font-medium text-westetics-neutral-950">E-mail do Administrador*</label>
        <input
          type="email"
          id="ownerEmail"
          formControlName="ownerEmail"
          class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="email.admin@empresa.com"
        />
        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
          formCompanyContact.controls['ownerEmail']?.errors?.['required'] &&
          formCompanyContact.controls['ownerEmail']?.touched
        ">
          O e-mail é obrigatório.
        </span>
        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
          formCompanyContact.controls['ownerEmail']?.errors?.['emailTld'] &&
          formCompanyContact.controls['ownerEmail']?.touched
        ">
          Insira um e-mail válido (ex: nome@dominio.com).
        </span>
        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="formCompanyContact.controls['ownerEmail']?.errors?.['api']">
          {{ formCompanyContact.controls['ownerEmail'].errors?.['api'] }}
        </span>
      </div>
    </div>

    <!-- SENHA TEMPORÁRIA DO ADMIN -->
    <div class="mt-4">
      <div class="w-full">
        <label for="password" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Senha Temporária*</label>
        <p class="text-xs text-westetics-neutral-600 mb-2">
          Copie e envie esta senha ao administrador. Ele será obrigado a trocá-la no primeiro login.
        </p>
        <div class="flex gap-2">
          <input
            type="text"
            id="password"
            formControlName="password"
            readonly
            class="bg-gray-100 border border-gray-300 text-neutral-700 text-sm rounded-lg outline-none block w-full p-2.5 font-mono tracking-wider"
          />
          <button
            type="button"
            (click)="copyPassword()"
            class="px-3 py-2.5 text-sm rounded-lg border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-50 whitespace-nowrap flex items-center gap-1"
          >
            <svg *ngIf="!passwordCopied" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
            </svg>
            <svg *ngIf="passwordCopied" class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
            {{ passwordCopied ? 'Copiado!' : 'Copiar' }}
          </button>
          <button
            type="button"
            (click)="regeneratePassword()"
            class="px-3 py-2.5 text-sm rounded-lg border border-gray-300 text-westetics-neutral-800 hover:bg-gray-50 whitespace-nowrap flex items-center gap-1"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            Gerar nova
          </button>
        </div>
      </div>
    </div>

  </ng-container>

  <!-- ACTION (apenas no modo de criação) -->
  <div *ngIf="!isEditMode" class="flex justify-between mt-6">
    <button
      type="button"
      (click)="goBack()"
      class="w-[306px] py-[10px] text-westetics-purple-800 rounded-lg border border-westetics-purple-800"
    >
      Voltar
    </button>

    <button
      type="button"
      (click)="saveAndNext()"
      class="w-[306px] py-[10px] bg-westetics-purple-800 text-white rounded-lg"
    >
      Próximo
    </button>
  </div>

</form>
